var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-module-box"},[_c('div',{staticClass:"g-module",class:_vm.flex},[_vm._t("default")],2),(_vm.$slots.button)?_c('div',{staticClass:"flex-center g-module-button"},[_vm._t("button")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }